module.exports = __webpack_public_path__ + "static/media/undraw_world_re_768g.6ba2b9b9.png";